<template>
  <div class="month-days">
    <c-input
      type="select"
      floating-label="Дни месяца"
      label-full-name="Дни месяца"
      :value="localValue"
      :multiple="true"
      :items="items"
      :remove-selected="true"
      :required="invalid"
      :required-message="error"
      @input="onInput"
    >
    </c-input>

    <error-feedback v-if="error" :text="error"></error-feedback>
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import ErrorFeedback from "@/components/error-feedback";

export default {
  name: "c-select",

  components: {
    CInput,
    ErrorFeedback,
  },

  props: ["value", "error", "invalid"],

  data() {
    return {
      localValue: [],
    };
  },

  computed: {
    items() {
      return Array(31)
        .fill(null)
        .map((_, i) => ({
          value: i + 1,
          label: i + 1,
        }));
    },
  },

  watch: {
    value(v) {
      if (v.join("") === this.localValue.map((i) => i.value).join("")) return;
      this.localValue = v.map((i) => ({
        value: i,
        label: i,
      }));
    },
  },

  created() {
    this.localValue = this.value.map((i) => ({
      value: i,
      label: i,
    }));
  },

  methods: {
    onInput(value) {
      this.$emit(
        "input",
        value.map((i) => i.value),
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/vars";

.month-days {
  /deep/ {
    .c-input-container {
      width: 295px;
      padding: 10px;

      &_active {
        margin-top: 10px;

        right: 0;
      }
    }
    .c-input-container-list:not(.c-input-container-list-mobile) {
      display: flex;
      flex-wrap: wrap;
      margin: 7.5px;
    }

    .c-input-container-list-item {
      width: 32px;
      height: 32px;
      margin: 2.5px;
      border: 1px solid #d3d8df;
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      color: #8e9cbb;

      &:hover {
        background: transparent;
        color: #333333;
        border: 2px solid #ff238d;
      }

      &_disabled {
        pointer-events: all;
        cursor: pointer;
        color: #333333;
        border: 2px solid #ff238d;
      }
    }

    @include onlyMobile {
      .c-input-container {
        height: auto;

        padding: 20px 18px !important;
        &_active {
          margin-top: 0;
        }
      }

      .c-input-container-list:not(.c-input-container-list-mobile) {
        display: none;
      }

      .c-input-container-list.c-input-container-list-mobile {
        display: flex !important;
        flex-wrap: wrap;
      }

      .c-input-container-list-item {
        position: relative;

        &:hover {
          background: transparent;
          color: #8e9cbb;
          border: 1px solid #d3d8df;
        }

        .c-switcher {
          margin: 0;
          justify-content: center;
        }

        .c-switcher-checkbox {
          position: absolute;
          opacity: 0;
          visibility: hidden;
        }
        .c-switcher-label {
          color: #8e9cbb;
          margin: 0;
        }
        input:checked ~ .c-switcher-label {
          color: #333333;

          &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border: 2px solid #ff238d;
            border-radius: 50px;
          }
        }
      }
      .c-input-container-list-mobile-buttons {
        margin: 0;
        &:before {
          display: none;
        }
      }
    }
  }
}
</style>
